import React, { useState } from "react";
import "./ModalWrap.css";
function ModalWrap({ children }) {
  return (
    <div className="modal__wrap">
      <div className="modal__block"> {children}</div>
    </div>
  );
}

export default ModalWrap;
